module.exports = __webpack_public_path__ + "img/NO937888570.b6c8592a.png";